import type { WizardDraftData, WizardStepKey } from './types';

const DRAFT_STORAGE_KEY = 'hr_offboarding_draft';

// Save draft to localStorage
export const saveDraftToStorage = (draftData: WizardDraftData): void => {
  try {
    const updatedDraft = {
      ...draftData,
      updatedAt: new Date().toISOString(),
    };
    localStorage.setItem(DRAFT_STORAGE_KEY, JSON.stringify(updatedDraft));
  } catch (error) {
    console.error('Error saving draft to storage:', error);
  }
};

// Load draft from localStorage
export const loadDraftFromStorage = (): WizardDraftData | null => {
  try {
    const stored = localStorage.getItem(DRAFT_STORAGE_KEY);
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (error) {
    console.error('Error loading draft from storage:', error);
  }
  return null;
};

// Clear draft from localStorage
export const clearDraftFromStorage = (): void => {
  try {
    localStorage.removeItem(DRAFT_STORAGE_KEY);
  } catch (error) {
    console.error('Error clearing draft from storage:', error);
  }
};

// Check if draft exists
export const hasDraft = (): boolean => {
  return loadDraftFromStorage() !== null;
};

